import { useTranslation } from "react-i18next";
import { savoirFaires } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditSavoirFaire = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={savoirFaires} label={i18n.language === "fr" ? "Savoir faire" : "Know-how"} />
    );
}

export default EditSavoirFaire;